<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>网络</el-breadcrumb-item>
        <el-breadcrumb-item>网络总工单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
        <el-radio-button label="2">网络总工单</el-radio-button>
      </el-radio-group>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="建单时间">
                <el-date-picker v-model="searchForm.create_time" type="daterange" range-separator="-"
                  style="width: 100%" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                  @change="handleDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="工单类型">
                <el-select clearable v-model="searchForm.order_level" placeholder="请选择">
                  <el-option
                    v-for="item in category_level_4Options[tabPosition]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="6">
              <el-form-item label="工单单号">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工作工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单类型">
                <el-select v-model="searchForm.ticketType_ancy" placeholder="请选择工单类型" clearable filterable>
                  <el-option v-for="item in ticketTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理人">
                <el-input v-model="searchForm.handler" placeholder="请输入idc科技英文名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="状态">
                <el-select v-model="searchForm.state" placeholder="请选择状态" clearable>
                  <el-option label="已取消" value="已取消"></el-option>
                  <el-option label="已完成" value="已完成"></el-option>
                  <el-option label="处理中" value="处理中"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域园区">
                <el-input v-model="searchForm.bizAreaName" placeholder="支持模糊搜索输入园区关键名字"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select v-model="searchForm.isLate" placeholder="请选择" clearable>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>

              </div>
            </el-col>
            <el-col :span="6">
              <div class="search-button" style="display: flex; justify-content: flex-end;">
                <el-button type="danger" @click="openSyncDialog">获取最新网络工单</el-button>
              </div>
            </el-col>
          </el-row>

        </el-form>
      </div>
    </el-card>
    <div class="title-en">网络总工单列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <!-- <el-button @click="handleExport">催办</el-button>
          <el-button @click="handleExport">审计派单</el-button> -->
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :align="column.align" :fixed="column.fixed">
            <template slot-scope="scope">
              <span v-if="column.prop === 'operation'">
                <el-button type="text" size="small" @click="handleViewDetail(scope.row)">查看详情</el-button>
              </span>
              <span v-else-if="column.prop === 'campusName'">{{
                scope.row.campusName === '张家口-怀来东园'
                  ? '怀来-东园'
                  : scope.row[column.prop] || '-'
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a v-if="scope.row.opTicketid"
                  :href="`https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`"
                  target="_blank">{{ scope.row.opTicketid }}</a>
                <span v-else>{{ scope.row.opTicketid || '-' }}</span>
              </span>
              <span v-else-if="['amount', 'realNum'].includes(column.prop)">
                {{
                  scope.row[column.prop] === 0 || scope.row[column.prop]
                    ? scope.row[column.prop]
                    : '-'
                }}
              </span>
              <el-tag v-else-if="column.prop === 'feedback_status'"
                :type="scope.row.feedback_status === '已完成' ? 'success' : scope.row.feedback_status === '处理中' ? 'warning' : scope.row.feedback_status === '待处理' ? 'info' : 'danger'"
                size="small">
                {{ scope.row.feedback_status || '-' }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'time_out'" :type="scope.row.time_out === '已超时' ? 'danger' : 'success'"
                size="small">
                {{ scope.row.time_out || '-' }}
              </el-tag>
              <span v-else-if="column.prop === 'state'">
                <i v-if="scope.row.state === '处理中'" class="el-icon-loading"
                  style="color: #e6a23c; margin-right: 5px; font-size: 25px;"></i>
                <i v-else-if="scope.row.state === '已完成'" class="el-icon-circle-check"
                  style="color: #67c23a; margin-right: 5px; font-size: 25px;"></i>
                {{ scope.row.state || '-' }}
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>
        <el-dialog title="获取最新网络工单" :visible.sync="syncDialogVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="syncForm" label-width="100px">
            <el-form-item label="开始月份">
              <el-date-picker v-model="syncForm.startMonth" type="month" placeholder="选择开始月份" format="yyyy-MM"
                value-format="yyyy-MM">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束月份">
              <el-date-picker v-model="syncForm.endMonth" type="month" placeholder="选择结束月份" format="yyyy-MM"
                value-format="yyyy-MM">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="syncDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSync" :loading="syncLoading">确定</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAllNetworkTicketInfoList, upDateAllNetworkTicketInfoList, getNetworkDiagnoseList, exportNetworkDiagnoseList } from '@/api/network';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      tabPosition: 1,
      showColumnsDialog: false,
      columns: [
        { prop: 'TicketId', label: '工单ID', width: 130 },
        { prop: 'title', label: '标题', width: 200 },
        { prop: 'createTime', label: '创建时间', width: 150 },
        { prop: 'expectFinishTime', label: '期望完成时间', width: 150 },
        { prop: 'state', label: '状态', width: 100 },
        { prop: 'counts', label: '数量', width: 80 },
        { prop: 'handler', label: '处理人员', width: 100 },
        { prop: 'SchemeType', label: '方案类型', width: 100 },
        { prop: 'ticketType_ancy', label: '工单类型(扩展)', width: 150 },
        { prop: 'ticketMonth_ancy', label: '工单月份', width: 120 },
        { prop: 'assigner', label: '指派人员', width: 100 },
        { prop: 'auditId', label: '审核ID', width: 100 },
        { prop: 'bizAreaName', label: '业务区域名称', width: 150 },
        { prop: 'completeTime', label: '完成时间', width: 150 },
        { prop: 'completer', label: '完成人员', width: 100 },
        { prop: 'expectOperateTime', label: '期望操作时间', width: 150 },
        { prop: 'finish_option_flag', label: '完成选项标志', width: 120 },
        { prop: 'inspectionId', label: '巡检ID', width: 100 },
        { prop: 'instanceId', label: '实例ID', width: 100 },
        { prop: 'isAudit', label: '是否审核', width: 100 },
        { prop: 'isDelay', label: '是否延期', width: 100 },
        { prop: 'isInspection', label: '是否巡检', width: 100 },
        { prop: 'InspectionResult', label: '巡检结果', width: 120 },
        { prop: 'isPause', label: '是否暂停', width: 100 },
        { prop: 'isRecheck', label: '是否复核', width: 100 },
        { prop: 'isResource', label: '是否资源', width: 100 },
        { prop: 'isRush', label: '是否加急', width: 100 },
        { prop: 'pauseCheckDelayTime', label: '暂停检查延迟时间', width: 150 },
        { prop: 'pausePic', label: '暂停图片', width: 100 },
        { prop: 'resourceId', label: '资源ID', width: 100 },
        { prop: 'ticketNo', label: '工单编号', width: 130 },
        { prop: 'rushMessage', label: '加急消息', width: 150 },
        { prop: 'supplyName', label: '供应商名称', width: 120 },
        { prop: 'ticketType', label: '工单类型', width: 150 },




      ],
      selectedColumns: [
        'InspectionResult',
        'SchemeType',
        'TicketId',
        'assigner',
        'auditId',
        'bizAreaName',
        'completeTime',
        'completer',
        'counts',
        'createTime',
        'expectFinishTime',
        'expectOperateTime',
        'finish_option_flag',
        'handler',
        'inspectionId',
        'instanceId',
        'isAudit',
        'isDelay',
        'isInspection',
        'isPause',
        'isRecheck',
        'isResource',
        'isRush',
        'pauseCheckDelayTime',
        'pausePic',
        'resourceId',
        'rushMessage',
        'state',
        'supplyName',
        'ticketNo',
        'ticketType',
        'ticketType_ancy',
        'ticketMonth_ancy',
        'title',
      ],
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      defaultSelectedColumns: [
        'InspectionResult',
        'SchemeType',
        'TicketId',
        'assigner',
        'auditId',
        'bizAreaName',
        'completeTime',
        'completer',
        'counts',
        'createTime',
        'expectFinishTime',
        'expectOperateTime',
        'finish_option_flag',
        'handler',
        'inspectionId',
        'instanceId',
        'isAudit',
        'isDelay',
        'isInspection',
        'isPause',
        'isRecheck',
        'isResource',
        'isRush',
        'pauseCheckDelayTime',
        'pausePic',
        'resourceId',
        'rushMessage',
        'state',
        'supplyName',
        'ticketNo',
        'ticketType',
        'ticketType_ancy',
        'ticketMonth_ancy',
        'title',
      ],
      visibleColumns: [],
      selectedRows: [],
      faults: [],
      searchForm: {
        create_time: [],
        start_time: '',
        end_time: '',
        order_level: undefined,
        SlALevel: '',
        ticket_id: '',
        opTicketid: '',
        handle_user: '',
        campusName: '',
        memo: '',
        state: '',
        bizAreaName: '',
        isLate: '',
      },
      category_level_4Options: {
        1: [{ value: '网络诊断与故障排查', label: '网络诊断与故障排查' }],
        2: [{ value: '网络诊断与故障排查', label: '网络诊断与故障排查' }],
      },
      // 删除未使用的computedCategoryOptions方法
      campusOptions: [
        { value: 'sh-lg', label: '上海-临港' },
        { value: 'sh-sy', label: '上海-书院' },
        { value: 'hz-dg', label: '杭州-东冠' },
      ],
      ticketTypeOptions: [
        { value: '维修单', label: '维修单' },
        { value: '诊断单', label: '诊断单' },
        { value: '特殊变更', label: '特殊变更' },
        { value: '网络下架', label: '网络下架' },
        { value: '模块安装', label: '模块安装' },
        { value: '光纤接入', label: '光纤接入' },
        { value: '网络巡检', label: '网络巡检' },
        { value: '裁撤巡检(ODF)', label: '裁撤巡检(ODF)' },
        { value: '裁撤巡检(专线)', label: '裁撤巡检(专线)' },
        { value: '裁撤巡检(机架)', label: '裁撤巡检(机架)' },
        { value: '通用驻场工单', label: '通用驻场工单' },
        { value: 'ODF裁撤:下架单', label: 'ODF裁撤:下架单' },
        { value: 'ODF裁撤:拆线单', label: 'ODF裁撤:拆线单' },
        { value: 'ODF裁撤:摸排单', label: 'ODF裁撤:摸排单' },
        { value: 'VPC专线裁撤', label: 'VPC专线裁撤' },
        { value: '机房巡检', label: '机房巡检' },
        { value: '链路查看', label: '链路查看' },
        { value: '零星布线', label: '零星布线' },
        { value: '零星线缆裁撤', label: '零星线缆裁撤' },
      ],
      syncDialogVisible: false,
      syncLoading: false,
      syncForm: {
        startMonth: '',
        endMonth: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.create_time = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.create_time);
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {

    //更新网络工单
    openSyncDialog() {
      this.syncDialogVisible = true;
      // 默认设置当前月份为开始和结束月份
      const currentMonth = this.$moment().format('YYYY-MM');
      this.syncForm = {
        startMonth: currentMonth,
        endMonth: currentMonth
      };
    },

    async handleSync() {
      if (!this.syncForm.startMonth || !this.syncForm.endMonth) {
        this.$message.warning('请选择开始月份和结束月份');
        return;
      }

      // 验证月份范围
      if (this.syncForm.startMonth > this.syncForm.endMonth) {
        this.$message.error('开始月份不能大于结束月份');
        return;
      }

      this.syncLoading = true;

      try {
        // 调用更新接口
        const params = {
          start_month: this.syncForm.startMonth,
          end_month: this.syncForm.endMonth
        };

        const response = await upDateAllNetworkTicketInfoList(params);

        if (response.data && response.data.code === 200) {
          this.$message.success(response.data.msg || '获取最新网络工单成功');
          this.syncDialogVisible = false;
          // 重新获取列表数据
          this.fetchFaultData();
        } else {
          this.$message.error(response.data.msg || '获取最新网络工单失败');
        }
      } catch (error) {
        console.error('获取最新网络工单失败:', error);
        this.$message.error('获取最新网络工单失败');
      } finally {
        this.syncLoading = false;
      }
    },
    //园区获取数据接口
    async getCampusData() {
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data;
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = '';
        this.searchForm.end_time = '';
      }
    },
    fetchFaultData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        category_level: Number(this.tabPosition),
        ...this.searchForm,
      };
      delete params.create_time;
      getAllNetworkTicketInfoList(params)
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res.data);
            this.faults = res.data.data.data || [];
            this.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error('获取列表失败:', err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        create_time: [],
        start_time: '',
        end_time: '',
        order_level: undefined,
        SlALevel: '',
        ticket_id: '',
        opTicketid: '',
        memo: '',
        feedback_status: '',
        handle_user: '',
        campus: '',
        ticketLevel: '',
        time_out: '',
        state: '',
        bizAreaName: '',
        isLate: '',
      };

      this.tabPosition = '1';
      this.currentPage = 1;
      this.fetchFaultData();
    },
    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.loading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            export_excel:"1",
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  value !== '' && value !== null && value !== undefined && key !== 'create_time'
              )
            ),
          };

          const response = await getAllNetworkTicketInfoList(params);

          if (response.data) {
            const allData = response.data.data.data || [];
            // const allData = response.data.data.list || [];
            // 转换数据格式
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (column.prop === 'create_time' && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  } else if (column.prop === 'campus' && value === '张家口-怀来东园') {
                    value = '怀来-东园';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '网络总工单');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `网络总工单${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据
          if (this.selectedRows.length === 0) {
            this.$message.warning('没有数据可导出');
            return;
          }

          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.columns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (column.prop === 'create_time' && value) {
                  value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                } else if (column.prop === 'campus' && value === '张家口-怀来东园') {
                  value = '怀来-东园';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '网络总工单');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `网络总工单${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleTabChange() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.opTicketid}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>